var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3301_4875)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1894 58.8404C38.0237 52.6095 54.8031 37.3115 54.8031 25.2921C54.8031 11.8759 43.3633 1 29.2517 1C15.14 1 3.70029 11.8759 3.70029 25.2921C3.70029 37.3115 20.4797 52.6095 27.314 58.8405C27.7806 59.2659 28.2009 59.6491 28.5663 59.9861C28.9579 60.3472 29.5455 60.3472 29.9371 59.9861C30.3025 59.6491 30.7228 59.2659 31.1894 58.8404ZM30.8379 52.5433C36.4296 47.4662 50.1582 35.0012 50.1582 25.2076C50.1582 14.2759 40.7984 5.41406 29.2525 5.41406C17.7066 5.41406 8.34677 14.2759 8.34677 25.2076C8.34677 35.0012 22.0754 47.4663 27.6671 52.5433C27.9964 52.8423 28.2975 53.1157 28.5659 53.3614C28.9576 53.72 29.5473 53.72 29.939 53.3614C30.2075 53.1157 30.5086 52.8423 30.8379 52.5433Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2511,
    cy: 25.2912,
    rx: 6.96856,
    ry: 6.62511,
    fill: "#BBBBBB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3301_4875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLarge);
export default __webpack_public_path__ + "static/media/location-large.e40cd44419167fcb94ee74d6ba34a542.svg";
export { ForwardRef as ReactComponent };